import { render, staticRenderFns } from "./SelfAppraisal.vue?vue&type=template&id=5dda1094&scoped=true&"
import script from "./SelfAppraisal.vue?vue&type=script&lang=js&"
export * from "./SelfAppraisal.vue?vue&type=script&lang=js&"
import style0 from "./SelfAppraisal.vue?vue&type=style&index=0&id=5dda1094&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dda1094",
  null
  
)

export default component.exports